module.exports = __webpack_public_path__ + "static/img/组13.85ab07e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/组13.png
// module id = PevL
// module chunks = 1